<template>
  <el-form-item
    :label="label"
    class="blank"
    :prop="prop"
  >
    <el-input
      type="hidden"
      resize="none"
    />
  </el-form-item>
</template>

<script>

export default {
  components: {
  },
  props: {
    value: Number,
    label: {
      type: String,
      default: ''
    },
    prop: {
      type: String,
      default: 'blank'
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    searchCond: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
    }
  },
  mounted () {
    const inner = this.$el.querySelector('.el-input__inner')
    inner.setAttribute('maxlength', '100')
  },
  methods: {
  }
}
</script>

<style lang="scss">
.el-form-item {
  &.blank {
    .el-form-item__content {
        width: 12em;
        .el-input{
          .el-input__inner{
            text-align:right;
          }
        }
    }

  }
}
</style>
